export default __webpack_public_path__ + "static/media/Background 5_00028.a7f865ec.png";